/* @flow */
import { rem, em } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { phablet } from '@braindate/ui/lib/token/mediaQuery';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

const paddingLeftDesktop = rem(50);

export default {
  body: {
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    color: ({ theme }: ThemeFunction) => theme.textColor,

    paddingBottom: em(25),
  },
  socialSharingSection: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    marginBottom: 8,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: em(20),
    paddingBottom: em(20),
    paddingLeft: em(18),
    paddingRight: em(18),
    [phablet]: {
      paddingTop: em(50),
      paddingLeft: paddingLeftDesktop,
      flexDirection: 'row',
    },
  },
  title: {
    display: 'block',
    margin: 0,
    fontWeight: 600,
    fontSize: rem(20, baseFontSize),
    lineHeight: rem(24, baseFontSize),
    wordWrap: 'break-word',
    paddingBottom: rem(20),
    paddingLeft: rem(20),
    [phablet]: { paddingLeft: paddingLeftDesktop, paddingRight: em(40) },
  },
  favorite: {
    position: 'absolute',
    top: em(10),
    right: em(0),
    [phablet]: {
      top: em(25),
      right: em(25),
    },
  },
  label: {
    display: 'block',
    marginBottom: '0.25em',
    paddingBottom: em(10),
    paddingRight: em(10),
    marginTop: 0,
    color: ({ theme }: ThemeFunction) => theme.accentColor,

    fontSize: rem(16, baseFontSize),
    fontWeight: 500,
    paddingLeft: em(18),
    [phablet]: { paddingLeft: paddingLeftDesktop },
  },
  how: {
    marginBottom: '1em',
  },
  howValue: {
    display: 'block',
    color: ({ theme }: ThemeFunction) => theme.textColorSecondary,
    lineHeight: rem(19, baseFontSize),
    fontSize: rem(16, baseFontSize),
    fontWeight: 400,
    marginTop: '0.5em',
    paddingLeft: em(18),
    paddingRight: em(18),
    [phablet]: {
      paddingLeft: paddingLeftDesktop,
      paddingRight: paddingLeftDesktop,
    },
  },
  stats: {
    marginTop: '1em',
    marginBottom: '-0.5em',
  },
  spotsLabel: {
    marginBottom: 0,
    paddingBottom: 0,
  },
  spotsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1em',
    paddingRight: em(24),
  },
  spots: {
    fontSize: 14,
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  time: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    verticalAlign: 'top',
    paddingBottom: em(30),
    fontSize: 14,
    fontStyle: 'italic',
    fontWeight: 400,
    WebkitFontSmoothing: 'antialiased',
    paddingLeft: em(18),
    [phablet]: {
      paddingLeft: em(50),
    },
  },
  clockIcon: {
    width: 16,
    marginRight: '0.3em',
  },
  host: {
    display: 'flex',
    flexDirection: 'row',
  },
  subNav: {
    position: 'absolute',
    textAlign: 'center',
    transform: 'translateX(235%)',
    padding: [em(10), em(1)],
    [phablet]: {
      transform: 'translateX(-95%)',
    },
  },
  subNavItem: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: em(10),
  },
  tags: {
    paddingBottom: em(30),
  },
  sharingBtn: {
    background: 'none',
    // position: 'absolute',
    padding: 0,

    // top: em(10),
    // right: em(0),
    // [phablet]: {
    // right: em(25),
    // },
  },
  topicLabels: {
    paddingRight: 10,
    width: '100%',
    display: 'flex',
    columnGap: 8,
  },
  location: {
    paddingLeft: em(20),
    marginBottom: '1.8em',
    [phablet]: { paddingLeft: paddingLeftDesktop },
  },

  container: {
    paddingLeft: em(18),
    [phablet]: {
      paddingLeft: em(50),
    },
  },
  infoIcon: {
    marginLeft: 5,
    fontSize: 9,
  },
};
